let _ = require('lodash');
let $ = require('jquery');
let qs = require('qs');
let cookie = require('../../actions/cookie');
let errorConverter = require('../../helpers/errorToObjectConverter');
const DEFAULT_TIMEOUT = 60000;
const BITRIX_TOKEN = 'bitrix_access_token';
const BITRIX_DOMAIN = 'bitrix_domain';
const BITRIX_MEMBER_ID = 'bitrix_member_id';

function setBitrixCookie (auth, context) {
    // токен Битрикса живёт 1 час, но на всякий случай считаем, что 45 минут
    let expires = new Date(Date.now() + (45 * 60 * 1000));

    context.cookie.set({
        key: BITRIX_TOKEN,
        value: _.get(auth, 'access_token'),
        path: '/',
        expires
    });

    context.cookie.set({
        key: BITRIX_DOMAIN,
        value: _.get(auth, 'domain'),
        path: '/',
        expires
    });

    context.cookie.set({
        key: BITRIX_MEMBER_ID,
        value: _.get(auth, 'member_id'),
        path: '/',
        expires
    });
}

/**
 * Класс для работы с удаленными хранилищами.
 */
class API {
    constructor (locator) {
        this._uhr = locator.resolve('uhr');
        this._config = locator.resolve('config');
        this._logger = locator.resolve('logger');
    }

    getAuthHeaders (context, locator, options, api) {
        if (options.noAuthorizationToken === true) {
            return new Promise(function (resolve, reject) {
                resolve({});
            });
        }

        let classContext = this;
        // тут логика по использованию и обновлению токена битрикс
        if (locator) {
            let bitrix;
            try {
                bitrix = locator.resolve('bitrix');
            } catch (ex) {
            }
            // используем авторизацию Битрикс, если сейчас работаем с Битрикс
            if (bitrix && bitrix._bx) {
                let bitrixToken = context.cookie.get(BITRIX_TOKEN);
                if (bitrixToken) {
                    return new Promise(function (resolve, reject) {
                        let auth = {
                            Authorization: `Bearer ${bitrixToken}`,
                            AuthorizationProvider: 'Bitrix',
                            BitrixDomain: context.cookie.get(BITRIX_DOMAIN),
                            BitrixMemberId: context.cookie.get(BITRIX_MEMBER_ID)
                        };
                        resolve(auth);
                    });
                } else {
                    // чтобы избежать повторных ненужных изменений токена записываем промис обновления
                    // в this.refreshAuthPromise и используем его, если он есть
                    if (this.refreshAuthPromise) {
                        return this.refreshAuthPromise;
                    }
                    this.refreshAuthPromise = new Promise(function (resolve, reject) {
                        function greet (newAuth) {
                            setBitrixCookie(newAuth, context);
                            bitrixToken = _.get(newAuth, 'access_token');
                            let domain = _.get(newAuth, 'domain');
                            let memberId = _.get(newAuth, 'member_id');
                            // если Битрикс возвращает нам аутентификацию без домена, то логируем это говно
                            if (!domain || domain.length <= 0) {
                                this.logOnWebApi(context, locator,
                                    {
                                        level: 'error',
                                        message: 'bitrix.refreshAuth returned empty domain newAuth=' +
                                            JSON.stringify(newAuth)
                                    });
                            }
                            let auth = {
                                Authorization: `Bearer ${bitrixToken}`,
                                AuthorizationProvider: 'Bitrix',
                                BitrixDomain: domain,
                                BitrixMemberId: memberId
                            };
                            this.refreshAuthPromise = null;
                            resolve(auth);
                        }
                        bitrix.refreshAuth(_.bind(greet, classContext));
                    });
                    return this.refreshAuthPromise;
                }
            }
        }

        // тут логика по использованию и обновлению токенов паспорта
        let token = options.token || context.cookie.get('access_token');
        return new Promise(function (resolve, reject) {
            // если есть активный токен пасплорта, то используем его
            if (token) {
                resolve({
                    Authorization: `Bearer ${token}`,
                    AuthorizationProvider: 'TwoGis'
                });
                // иначе получаем новый токен и записываем в cookies
            } else {
                let refreshToken = context.cookie.get('refresh_token');
                if (!refreshToken) {
                    resolve({});
                    return;
                }
                let methodParams = {
                    grant_type: 'refresh',
                    client_id: 'hermes',
                    refresh_token: refreshToken
                };

                let request = api.refreshToken(context, { methodParams });
                request.then((data) => {
                    let code = _.get(data, 'status.code');
                    let authResponse = _.get(data, 'content');
                    if (code !== 200) {
                        reject(code);
                        return;
                    }

                    cookie.setSessionToken({ auth: authResponse }, null, null, { context });
                    resolve({
                        Authorization: `Bearer ${authResponse.access_token}`,
                        AuthorizationProvider: 'TwoGis'
                    });
                });
            }
        });
    }

    /**
     * Логин пользователя
     * @param {Object} context
     * @param {Object} loginData
     * @returns {*}
     */
    authUser (context, { loginData }) {
        let options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            noAuthorizationToken: true
        };

        return this._auth('POST', 'oauth/token', loginData, context, options);
    }

    /**
     * Обновление протухшего токена Паспорта
     * @param {Object} context
     * @param {Object} loginData
     * @returns {*}
     */
    refreshToken (context, { methodParams }) {
        let options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'

            },
            noAuthorizationToken: true
        };

        return this._auth('POST', 'oauth/token', methodParams, context, options);
    }

    /**
     * Отправка запроса на регистрацию пользователя в Auth
     * @param {Object} context
     * @param {Object} registerData
     * @returns {*}
     */
    registerAuthUser (context, { registerData, queryData }) {
        let query = qs.stringify(queryData);

        let options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        };

        return this._auth('POST', `users?${query}`, registerData, context, options);
    }

    /**
     * Отсылает повторно на почтовый ящик пользователя ссылку на подтверждение почтового ящика
     * @param {Object} context
     * @param {Object} queryData
     * @returns {*}
     */
    sendConfirmationMail (context, { queryData }) {
        let query = qs.stringify(queryData);

        let options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        };

        return this._auth('POST', `users/me/confirmation?${query}`, { grant_type: 'email' }, context, options);
    }

    /**
     * Отправка запроса на регистрацию пользователя в Hermes
     * @param {Object} context
     * @param {Object} registerData
     * @param {Object} token
     * @returns {*}
     */
    registerHermesUser (context, locator, { registerData, token }) {
        let options = {
            token
        };

        return this._export('POST', 'api/user/register', registerData, context, locator, options);
    }

    registerStubHermesUser (context, locator, { registerData }) {
        return this._export('POST', 'api/user/register/stub', registerData, context, locator);
    }

    /**
     * Отправка запроса на восстановление пароля в Auth
     * @param {Object} context
     * @param {String} email
     * @returns {*}
     */
    restorePassword (context, { restoreData, queryData }) {
        let query = qs.stringify(queryData);

        let options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        };

        return this._auth('POST', `users/recovery?${query}`, restoreData, context, options);
    }

    /**
     * Отправка нового пароля в Auth (восстановление пароля по токену восстановления)
     * @param {Object} context
     * @param {String} email
     * @returns {*}
     */
    passwordChange (context, { password, restoreToken }) {
        let options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        };

        return this._auth('POST', `l/${restoreToken}/password_change`, { password }, context, options);
    }

    /**
     * Смена пароля в Auth по действующему токену
     * @param {Object} context
     * @param {String} email
     * @returns {*}
     */
    passwordChangeActual (context, { password, passwordNew }) {
        let accessToken = context.cookie.get('access_token');
        let formData = {
            password: password,
            password_new: passwordNew,
            flush_sessions: 0
        };
        let options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            noAuthorizationToken: true
        };

        return this._auth('PUT', `users/me/password?access_token=${accessToken}`, formData, context, options);
    }

    logOnWebApi (context, locator, { level, message }) {
        let options = {
            disableLogging: true,
            noAuthorizationToken: true
        };
        return this._export('POST', `api/logger?level=${level}`, JSON.stringify(errorConverter.convert(message)),
            context, locator, options);
    }

    /**
     * Получение информации о пользователе
     * @param {Object} context
     * @param {Object} dropCache
     * @param {Object} token
     * @returns {*}
     */
    getCurrentUser (context, locator, { dropCache, token }) {
        let options = {
            dropCache,
            token
        };

        return this._export('GET', 'api/user', {}, context, locator, options);
    }

    getBitrixUser (context, locator) {
        return this._export('GET', 'api/user/bitrix', {}, context, locator);
    }

    getUserById (context, locator, { userId }) {
        return this._export('GET', `api/users/${userId}`, {}, context, locator);
    }

    updateUserInfo (context, locator, { userId, data }) {
        return this._export('PUT', `api/users/${userId}`, data, context, locator);
    }

    getOrderPrice (context, locator, parameters, orderTypeId) {
        let options = {
            timeout: 60000
        };
        return this._export('POST', `api/data/calculatePrice/${orderTypeId}`, parameters, context, locator, options);
    }

    getAvailableParameters (context, locator) {
        let options = {
            timeout: 60000
        };
        return this._export('GET', 'api/data/availableParameters', {}, context, locator, options);
    }

    uploadTreeInputRubrics (context, locator, treeInput) {
        return this._export('POST', 'api/data/selectRubrics', JSON.stringify(treeInput), context, locator);
    }

    uploadTreeInputCities (context, locator, treeInput, orderTypeId) {
        return this._export('POST', `api/data/selectCities?orderTypeId=${orderTypeId}`, JSON.stringify(treeInput),
            context, locator);
    }

    getPrices (context, locator) {
        return this._export('GET', 'api/data/prices', {}, context, locator);
    }

    getColumns (context, locator) {
        return this._export('GET', 'api/data/columns', {}, context, locator);
    }

    getDocumentTypes (context, locator) {
        return this._export('GET', 'api/data/documentTypes', {}, context, locator);
    }

    getStatisticChunk (context, locator, { orderId, xStartIndex, yStartIndex, xAmount, yAmount, xExtended, yExtended,
        isTransposed, isByBranch }) {
        return this._export(
            'POST',
            `api/order/statistic/${orderId}`,
            {
                xStartIndex,
                yStartIndex,
                xAmount,
                yAmount,
                xExtended,
                yExtended,
                isTransposed,
                isByBranch
            },
            context,
            locator
        );
    }

    getExportResults (context, locator, orderId) {
        return this._export('GET', `api/order/${orderId}/exportResults`, {}, context, locator);
    }

    getOrderState (context, locator, orderId) {
        return this._export('GET', `api/order/${orderId}/state`, {}, context, locator);
    }

    getHasBitrixLeads (context, locator, orderId) {
        return this._export('GET', `api/order/${orderId}/hasBitrixLeads`, {}, context, locator);
    }

    isBackendInStandardState (context, locator) {
        return this._export('GET', 'api/state/isExportAllowed', {}, context, locator);
    }

    /**
     * Получить заказ пользователя
     * @param {Object} context
     * @param {Number} orderId
     * @returns {*}
     */
    getUserOrder (context, locator, { orderId }) {
        let orderIdString = '';
        if (orderId) {
            orderIdString = orderId;
        }

        return this._export('GET', `api/order/${orderIdString}`, {}, context, locator);
    }

    getUserDraftOrder (context, locator) {
        return this._export('GET', 'api/order/draft', {}, context, locator);
    }

    /**
     * Получить список всех заказов пользователя
     * @param {Object} context
     * @returns {*}
     */
    getOrders (context, locator, { queryData }) {
        let query = qs.stringify(queryData);

        return this._export('GET', `api/orders?${query}`, {}, context, locator);
    }

    /**
     * Получить список пользователей
     * @param {Object} context
     * @param {Object} locator
     * @returns {*}
     */
    getUsers (context, locator) {
        return this._export('GET', 'api/users', {}, context, locator);
    }

    /**
     * Получить список менеджеров
     * @param {Object} context
     * @param {Object} locator
     * @returns {*}
     */
    getManagers (context, locator) {
        return this._export('GET', 'api/managers', {}, context, locator);
    }

    /**
     * Установка типа оплаты заказа
     * @param {Object} context
     * @param {Object} locator
     * @returns {*}
     */
    setPaymentType (context, locator, { paymentId, orderId }) {
        return this._export('PUT', `api/order/${orderId}/paymentType/${paymentId}`, {}, context, locator);
    }

    /**
     * Установка стоимости заказа
     * @param {Object} context
     * @param {Object} locator
     * @returns {*}
     */
    updateOrderAmount (context, locator, { orderId, amount }) {
        return this._export(
            'PUT',
            `api/order/${orderId}/amount`,
            amount,
            context,
            locator
        );
    }

    /**
     * Установка названия заказа
     * @param context
     * @param name
     * @param orderId
     * @returns {*}
     */
    setName (context, locator, { name, orderId }) {
        return this._export(
            'PUT',
            `api/order/${orderId}/name`,
            JSON.stringify(name),
            context,
            locator
        );
    }

    /**
     * Установка пользователя для заказа
     * @param {Object} context
     * @returns {*}
     */
    setUser (context, locator, { userId, orderId }) {
        return this._export('PUT', `api/order/${orderId}/user/${userId}`, {}, context, locator);
    }

    /**
     * Установка менеджера для заказа
     * @param {Object} context
     * @returns {*}
     */
    setManager (context, locator, { managerId, orderId }) {
        return this._export('PUT', `api/order/${orderId}/manager/${managerId}`, {}, context, locator);
    }

    /**
     * Перевести заказ в следующий статус
     * @param {Object} context
     * @param {Object} args
     * @param {Number} orderId
     * @param {Object} apiArgs
     * @returns {*}
     */
    moveOrderToNextState (context, locator, { orderId, apiArgs }) {
        return this._export(
            'POST',
            `api/manageOrders/${orderId}/moveOrderToNextState`,
            apiArgs,
            context,
            locator
        );
    }

    /**
     * Пользователь принимает лицензионное соглашение
     * @param {Object} context
     * @param {Object} locator
     * @param {Number} orderId
     * @returns {*}
     */
    acceptLicenseAgreement (context, locator, { orderId }) {
        return this._export(
            'POST',
            `api/manageOrders/${orderId}/acceptLicenseAgreement`,
            {},
            context,
            locator
        );
    }

    /**
     * Пользователь/менеджер подтверждает согласие с тем, что данные изменились и он не против
     * @param {Object} context
     * @param {Number} orderId
     * @returns {*}
     */
    confirmDataChanged (context, locator, { orderId }) {
        return this._export(
            'POST',
            `api/manageOrders/${orderId}/confirmDataChanged`,
            {},
            context,
            locator
        );
    }

    /**
     * Перевести заказ в архив
     * @param {Object} context
     * @param {Object} locator
     * @param {Number} orderId
     * @returns {*}
     */
    archiveOrder (context, locator, { orderId }) {
        return this._export(
            'POST',
            `api/manageOrders/${orderId}/archive`,
            {},
            context,
            locator
        );
    }

    /**
     * Загрузить файлы на сервер
     * @param {Object} context
     * @param {Object} locator
     * @param {Number} data.orderId
     * @param {Number} data.documentTypeId
     * @param {Object} data.formData
     * @returns {*}
     */
    uploadFile (context, locator, { orderId, documentTypeId, formData }) {
        let token = context.cookie.get('access_token');

        return $.ajax({
            url: `${this.getExportApiUrl(context)}api/attachment/upload/${orderId}/${documentTypeId}`,
            type: 'POST',
            headers: { Authorization: `Bearer ${token}` },
            data: formData,
            async: true,
            cache: false,
            contentType: false,
            processData: false
        });
    }

    /**
     * Загрузить файл результата на сервер
     * @param {Object} context
     * @param {Object} locator
     * @param {Number} data.orderId
     * @param {Object} data.formData
     * @returns {*}
     */
    uploadResultFile (context, locator, { orderId, formData }) {
        let token = context.cookie.get('access_token');

        return $.ajax({
            url: `${this.getExportApiUrl(context)}api/attachment/upload/${orderId}/result`,
            type: 'POST',
            headers: { Authorization: `Bearer ${token}` },
            data: formData,
            async: true,
            cache: false,
            contentType: false,
            processData: false
        });
    }

    /**
     * Получить адрес api Экспорта
     * @param {Object} context
     * @param {Number} fileId
     * @returns {string}
     */
    getExportApiUrl (context) {
        let endpoint = this._config.exportAPI;
        let base = endpoint.endsWith('/') ? endpoint : endpoint + '/';
        return this.getUrl(context, base);
    }

    downloadRubricsFile (context, locator) {
        let url = `${this.getExportApiUrl(context)}api/data/downloadRubrics`;
        return this.downloadFileByUrl(context, locator, url);
    }

    downloadCitiesFile (context, locator, orderTypeId) {
        let url = `${this.getExportApiUrl(context)}api/data/downloadCities/${orderTypeId}`;
        return this.downloadFileByUrl(context, locator, url);
    }

    downloadFile (context, locator, { fileId, fileName }, onProgressHandler) {
        let url = `${this.getExportApiUrl(context)}api/attachment/download/${fileId}`;
        let authPromise = this.getAuthHeaders(context, locator, {}, this);
        return authPromise.then((authHeaders) => new Promise(function (resolve, reject) {
            let request = new XMLHttpRequest();
            request.open('GET', url, true);
            _.each(Object.keys(authHeaders), (key) => {
                request.setRequestHeader(key, authHeaders[key]);
            });
            request.responseType = 'arraybuffer';
            request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            request.onload = function () {
                var type = request.getResponseHeader('Content-Type');
                resolve({ code: this.status, content: request.response, contentType: type });
            };
            if (onProgressHandler) {
                request.onprogress = onProgressHandler;
            }
            request.onerror = function () {
                reject({
                    status: this.status,
                    statusText: request.statusText
                });
            };
            request.send();
        }));
    }

    downloadFileByUrl (context, locator, url) {
        let authPromise = this.getAuthHeaders(context, locator, {}, this);
        return authPromise.then((authHeaders) => new Promise(function (resolve, reject) {
            let request = new XMLHttpRequest();
            request.open('GET', url, true);
            _.each(Object.keys(authHeaders), (key) => {
                request.setRequestHeader(key, authHeaders[key]);
            });
            request.responseType = 'arraybuffer';
            request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            request.onload = function () {
                let type = request.getResponseHeader('Content-Type');
                let contentDisposition = request.getResponseHeader('Content-Disposition');
                resolve({
                    code: this.status,
                    content: request.response,
                    contentType: type,
                    contentDisposition: contentDisposition
                });
            };
            request.onerror = function () {
                reject({
                    status: this.status,
                    statusText: request.statusText
                });
            };
            request.send();
        }));
    }

    downloadDraftFile (context, locator, { orderId, typeId }) {
        let url = `${this.getExportApiUrl(context)}api/order/${orderId}/documents/drafts/${typeId}`;
        return this.downloadFileByUrl(context, locator, url);
    }

    downloadStatisticFile (context, locator, { orderId, isTransposed, isByBranch }) {
        let url = `${this.getExportApiUrl(context)}api/order/statistic/${orderId}/excel?isTransposed=${isTransposed}&isByBranch=${isByBranch}`;
        return this.downloadFileByUrl(context, locator, url);
    }

    /**
     * Добавить тип обязательного документа для заказа
     * @param {Object} context
     * @param {Number} orderId
     * @param {Number} documentTypeId
     * @returns {*}
     */
    addDocumentType (context, locator, { orderId, documentTypeId }) {
        return this._export(
            'PATCH',
            `api/order/${orderId}/addDocumentType/${documentTypeId}`,
            {},
            context,
            locator
        );
    }

    /**
     * Удалить тип обязательного документа для заказа
     * @param {Object} context
     * @param {Number} orderId
     * @param {Number} documentTypeId
     * @returns {*}
     */
    removeDocumentType (context, locator, { orderId, documentTypeId }) {
        return this._export(
            'PATCH',
            `api/order/${orderId}/removeDocumentType/${documentTypeId}`,
            {},
            context,
            locator
        );
    }

    /**
     * Удалить файл приложенный к заказу
     * @param {Object} context
     * @param {Number} documentId
     * @returns {*}
     */
    deleteDocument (context, locator, { documentId }) {
        return this._export(
            'DELETE',
            `api/attachment/delete/${documentId}`,
            {},
            context,
            locator
        );
    }

    postOrderParameters (context, locator, { selectedParameters }) {
        return this._export(
            'POST',
            'api/order',
            selectedParameters,
            context,
            locator
        );
    }

    updateOrderParameters (context, locator, { orderId, selectedParameters }) {
        return this._export(
            'PUT',
            `api/order/${orderId}`,
            selectedParameters,
            context,
            locator
        );
    }

    getOnlinePaymentForm (context, locator, { orderId }) {
        return this._export(
            'GET',
            `api/payment/${orderId}/form`,
            {},
            context,
            locator
        );
    }

    isEmailAssociated (context, locator, email) {
        return this._export('GET', `api/user/isEmailAssociated?email=${email}`, {}, context, locator);
    }

    getCountries (context, locator) {
        return this._export('GET', 'api/user/getCountries', {}, context, locator);
    }

    /**
     * "Повторить заказ"
     * @param context
     * @param orderId
     * @returns {*}
     */
    repeatOrder (context, locator, { orderId }) {
        let options = {
            timeout: 1200000
        };

        return this._export(
            'POST',
            `api/order/repeat/${orderId}`,
            {},
            context,
            locator,
            options
        );
    }

    exportLeads (context, locator, { orderId, leadMapping, isExportFree, isIncludeExportedFreeLeads }) {
        let body = {};
        if (leadMapping) {
            body = leadMapping;
        }
        let isExportFreeArg = isExportFree !== undefined ? isExportFree : false;
        let isIncludeExportedArg = isIncludeExportedFreeLeads !== undefined ? isIncludeExportedFreeLeads : false;
        return this._export('POST', `api/bitrix/exportLeads/${orderId}?isExportFree=${isExportFreeArg}` +
            `&isIncludeExportedFreeLeads=${isIncludeExportedArg}`,
            body, context, locator);
    }

    getLeadFields (context, locator, { orderId }) {
        return this._export('GET', `api/bitrix/leadFields/${orderId}`, {}, context, locator);
    }

    getExportJobProgress (context, locator, { exportJobId }) {
        return this._export('GET', `api/bitrix/jobProgress/${exportJobId}`, {}, context, locator);
    }

    /**
     * Формируем обертку для запроса
     * @param {String} endpoint
     * @return {Function}
     * @private
     */
    _request (endpoint) {
        var base = endpoint.endsWith('/') ? endpoint : endpoint + '/';
        var config = this._config;

        /**
         * Запрос к удаленному API
         * @param {String} method
         * @param {String} slug
         * @param {Object|String} data
         * @param {Object} context
         * @param {Object} locator
         * @param {Object} [options={}]
         * @return {Promise}
         */
        return (method, slug, data, context, locator, options = {}) => {
            let url = this.getUrl(context, base, slug);
            let authPromise = this.getAuthHeaders(context, locator, options, this);

            let params;
            let promisesChain = authPromise
                .then((auth) => {
                    let headers = Object.assign({ 'Content-Type': 'application/json' }, auth);

                    let defaults = {
                        url,
                        method: method,
                        data: _.isObject(data) ? _.omitBy(data, _.isUndefined) : data,
                        headers
                    };

                    let paramsData = {
                        headers: _.omitBy(options.headers, _.isUndefined),
                        timeout: _.get(options, 'timeout', DEFAULT_TIMEOUT),
                        withCredentials: options.withCredentials
                    };

                    params = _.chain(paramsData)
                        .defaultsDeep(defaults)
                        .omitBy(_.isUndefined)
                        .value();
                })
                .then(() => this._uhr.request(params))
                .then((response) => {
                    params.data = _.omit(params.data, 'password');
                    return response;
                });

            if (options.disableLogging !== true) {
                promisesChain = promisesChain.then((response) => this._logApiResponseError(context, response, params))
                    .then((response) => this._logApiResponseError(context, response, params))
                    .then((response) => this._logApiResponseWarn(context, response, params))
                    .then((response) => this._logApiTimeoutError(context, response, params))
                    .catch((error) => this._logApiRequestError(context, error, params));
            }

            return promisesChain;
        };
    }

    _logApiResponseError (context, response, params) {
        var method = _.get(params, 'method');
        var apiParams = _.get(params, 'data');
        var apiScheme = context.location.scheme;
        var apiUrl = this._getRequestURL(params);
        var codeHttp = _.get(response, 'status.code');
        var codeMeta = _.get(response, 'content.meta.code');
        var userReferrer = _.result(context, 'referrer.toString');
        var userHRef = _.result(context, 'location.toString');
        var userAgent = _.get(context, 'userAgent');

        if (this._isErrorCode(codeHttp)) {
            let text = _.get(response, 'status.text', codeHttp);
            let message = `HttpError: ${text}`;

            this._logger.error(message, {
                codeHttp, codeMeta,
                method, apiScheme,
                apiUrl, apiParams,
                userReferrer, userHRef,
                userAgent
            });
        } else if (this._isErrorCode(codeMeta)) {
            let error = _.get(response, 'content.meta.error');
            let text = _.get(error, 'message', codeMeta);
            let message = `ApiError: ${text}`;

            this._logger.error(message, {
                codeHttp, codeMeta,
                method, error, apiScheme,
                apiUrl, apiParams,
                userReferrer, userHRef,
                userAgent
            });
        }

        return response;
    }

    _logApiTimeoutError (context, response, params) {
        var method = _.get(params, 'method');
        var apiParams = _.get(params, 'data');
        var apiScheme = context.location.scheme;
        var apiUrl = this._getRequestURL(params);
        var codeHttp = _.get(response, 'status.code');
        var userReferrer = _.result(context, 'referrer.toString');
        var userHRef = _.result(context, 'location.toString');
        var userAgent = _.get(context, 'userAgent');

        if (codeHttp === 0) {
            let message = 'HttpError: Timeout';

            this._logger.error(message, {
                codeHttp,
                method, apiScheme,
                apiUrl, apiParams,
                userReferrer, userHRef,
                userAgent
            });
        }

        return response;
    }

    _logApiResponseWarn (context, response, params) {
        var method = _.get(params, 'method');
        var apiParams = _.get(params, 'data');
        var apiScheme = context.location.scheme;
        var apiUrl = this._getRequestURL(params);
        var codeHttp = _.get(response, 'status.code');
        var codeMeta = _.get(response, 'content.meta.code');
        var userReferrer = _.result(context, 'referrer.toString');
        var userHRef = _.result(context, 'location.toString');
        var userAgent = _.get(context, 'userAgent');

        if (this._isWarnCode(codeHttp)) {
            let text = _.get(response, 'status.text', codeHttp);
            let message = `HttpError: ${text}`;

            this._logger.warn(message, {
                codeHttp, codeMeta,
                method, apiScheme,
                apiUrl, apiParams,
                userReferrer, userHRef,
                userAgent
            });
        } else if (this._isWarnCode(codeMeta)) {
            let error = _.get(response, 'content.meta.error');
            let text = _.get(error, 'message', codeMeta);
            let message = `ApiError: ${text}`;

            this._logger.warn(message, {
                codeHttp, codeMeta,
                method, error, apiScheme,
                apiUrl, apiParams,
                userReferrer, userHRef,
                userAgent
            });
        }
        return response;
    }

    _logApiRequestError (context, error, params) {
        var data = {};
        var message = '';
        var method = _.get(params, 'method');
        var apiParams = _.get(params, 'data');
        var apiScheme = context.location.scheme;
        var apiUrl = this._getRequestURL(params);
        var userReferrer = _.result(context, 'referrer.toString');
        var userHRef = _.result(context, 'location.toString');
        var userAgent = _.get(context, 'userAgent');

        if (_.isError(error)) {
            data.stack = error.stack;
            message = `${error.name}: ${error.message}`;
        } else {
            message = JSON.stringify(error);
        }

        message = message || 'requestError';

        this._logger.error(message, Object.assign({
            method, error,
            apiParams, apiScheme, apiUrl,
            userReferrer, userHRef, userAgent
        }, data));
    }

    _getRequestURL (params) {
        var apiUrl = _.get(params, 'url');
        var apiParams = _.get(params, 'data');

        if (_.isEmpty(apiParams)) {
            return apiUrl;
        }

        if (_.isString(apiParams)) {
            return `${apiUrl}?${apiParams}`;
        }

        var queryStr = _.chain(apiParams)
            .map((value, key) => `${key}=${value}`)
            .join('&')
            .value();

        return `${apiUrl}?${queryStr}`;
    }

    _isErrorCode (code) {
        return /[345][0-9]{2}/.test(code) && !this._isWarnCode(code);
    }

    _isWarnCode (code) {
        return /401|403|404/.test(code);
    }

    getUrl (context, endpoint, slug = '') {
        var base = endpoint.endsWith('/') ? endpoint : endpoint + '/';

        var scheme = _.get(context, 'location.scheme') === 'https' ? 'https://' : 'http://';

        return /^http[s]?:\/\/.+/.test(base) ? `${base}${slug}` : `${scheme}${base}${slug}`;
    }

    /**
     * Возвращает обертку для запросов к Export API
     * @returns {Function}
     * @private
     */
    get _export () {
        return this._request(this._config.exportAPI);
    }

    get _auth () {
        return (method, slug, data, context, options = {}) => {
            return this._request(this._config.authAPI)(method, slug, data, context, null, options);
        };
    }
}

module.exports = API;



// WEBPACK FOOTER //
// ./services/api/index.js